// = Libs =
import axios, { AxiosInstance } from 'axios';

const ACCESS_DENIED = 403;

const API = {
  baseUrl: process.env.REACT_APP_API,
  EIOPUrl: process.env.REACT_APP_EIOP,
  NSIUrl: process.env.REACT_APP_NSI,
};

const API_INSTANCE: AxiosInstance = axios.create({
  baseURL: API.baseUrl,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*',
  },
});

API_INSTANCE.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status } = err.response;
    if (status === ACCESS_DENIED) {
      if (window.location.pathname === '/403') {
        return Promise.reject(err);
      }
      window.location.pathname = '/403';
    }
    return Promise.reject(err);
  }
);

const FILE_INSTANCE: AxiosInstance = axios.create({
  baseURL: API.baseUrl,
  withCredentials: false,
  headers: {
    'Content-Type': 'arraybuffer',
  },
});

FILE_INSTANCE.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status } = err.response;
    if (status === ACCESS_DENIED) {
      if (window.location.pathname === '/403') {
        return Promise.reject(err);
      }
      window.location.pathname = '/403';
    }
    return Promise.reject(err);
  }
);

const API_INSTANCE_NSI: AxiosInstance = axios.create({
  baseURL: API.NSIUrl,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

API_INSTANCE_NSI.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status } = err.response;
    if (status === ACCESS_DENIED) {
      if (window.location.pathname === '/403') {
        return Promise.reject(err);
      }
      window.location.pathname = '/403';
    }
    return Promise.reject(err);
  }
);

const API_INSTANCE_SWR: AxiosInstance = axios.create({
  baseURL: API.baseUrl,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

API_INSTANCE_SWR.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status } = err.response;
    if (status === ACCESS_DENIED) {
      if (window.location.pathname === '/403') {
        return Promise.reject(err);
      }
      window.location.pathname = '/403';
    }
    return Promise.reject(err);
  }
);

const SWR_REFRESH_SETTINGS = {
  revalidateOnFocus: false,
  // revalidateOnMount: false,
  revalidateOnReconnect: false,
  refreshWhenOffline: false,
  // refreshWhenHidden: false,
  refreshInterval: 0,
};

export {
  API,
  API_INSTANCE,
  API_INSTANCE_SWR,
  SWR_REFRESH_SETTINGS,
  API_INSTANCE_NSI,
  FILE_INSTANCE,
};
